import Resource from '@/plugins/sdk/Resource'
import { DATETIME, DATE, STRING, UUID, NUMBER, ITEM } from '@/plugins/sdk/fields'
import PortfolioType from '@/plugins/sdk/resources/Portfolio/Type'

export default class extends Resource {
  static name = 'budget'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      target: new NUMBER(),
      allocated: new NUMBER(),
      date_from: new DATE(),
      date_to: new DATE(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      portfolio_type: new ITEM(PortfolioType),
      parent: new ITEM(this)
    }
  }
}
